/* eslint-disable import/no-anonymous-default-export */
export default {
  userDetails: '/users/me',
  userDetailsbyId: (id: string) => `/users/${id}`,
  userModulesById: (id: string) => `/visualization/users/${id}/details`,
  userModules: '/visualization/modules',
  userSubmodules: (moduleId: string) => `/visualization/modules/${moduleId}/submodules`,
  userSubmoduleFilters: (submoduleId: string) => `/visualization/submodules/${submoduleId}/filters`,
  userSubmoduleFiltersValues: (submoduleId: string, filterId: string) =>
    `/visualization/submodules/${submoduleId}/filters/${filterId}/values`,
  userGuestToken: (submoduleId: string) => `/visualization/submodules/${submoduleId}/token`,
  userSubmoduleGames: (submoduleId: string, gamesParam: string[]) =>
    `/visualization/submodules/${submoduleId}/games${gamesParam?.length ? `?gameIds=${gamesParam.join(',')}` : ''}`,
  users: '/users',
  companies: '/companies',
  fundingCalculator: 'lead-magnet',
  fundingCalculatorDeatils: (id: string) => `/lead-magnet/${id}`,
  charts: (submoduleId: string) => `/visualization/submodules/${submoduleId}/charts`,
  chartById: (submoduleId: string, chartId: string, queryParams?: string) =>
    `/visualization/submodules/${submoduleId}/charts/${chartId}${queryParams || ''}`,
  customDashboardFilters: (submoduleId: string) =>
    `/visualization/submodules/${submoduleId}/filter-values`,
  chartCsvDownload: (submoduleId: string, chartId: string, queryParams?: string) =>
    `/visualization/submodules/${submoduleId}/charts/${chartId}/download${queryParams || ''}`,
  fetchRequestedSubmodules: () => '/visualization/submodule-requests',
  requestSubmodule: (requestId: string) => `/visualization/submodule-requests/${requestId}/request`,
  investmentRequests: '/investments/requests',
  investmentAdminRequests: '/investments/admin/requests',
  investmentsGamesById: (gameId: string) => `/investments/games/${gameId}`,
  categoriesAndGenres: '/games/categories-and-genres',
  investors: '/investments/admin/investors',
  addGame: '/self-serve/add-new-game',
  applicationDetails: (store: string, appUrl: string) =>
    `/self-serve/verify-game/${store}?appUrl=${encodeURIComponent(appUrl)}`,
  registerUser: '/self-serve/register',
  adminRegisterUser: '/self-serve/admin/register',
  adminEditSelfServe: (selfServeId: string) => `/self-serve/admin/edit/${selfServeId}`,
  selfServeDetails: '/self-serve/details',
  selfServeUpdateCategoryAndGenre: (selfServeId: string) =>
    `/self-serve/${selfServeId}/category-genre`,
  selfServeUpdateApplicationDetails: (selfServeId: string) => `/self-serve/${selfServeId}`,
  selfServeDashboardRequests: `/self-serve/admin/requests`,
  selfServeById: (selfServeId: string) => `/self-serve/admin/request/${selfServeId}`,
  selfServeDataAccess: (selfServeId: string) => `/self-serve/${selfServeId}/initiate`,
  selfServeRequestDashboard: (selfServeId: string, dashboardId: string) =>
    `/self-serve/${selfServeId}/dashboards/${dashboardId}/request`,
  selfServeNDADetails: (selfServeId: string) => `/self-serve/${selfServeId}/nda`,
  selfServeRefreshConfig: (gameId: string) => `/self-serve/${gameId}/refresh-config`,
  selfServeMMPConfig: `/self-serve/mmp-config`,
  selfServeCsvDownload: (queryParams?: string) =>
    `/self-serve/admin/requests/download${queryParams ? `?${queryParams}` : ''}`,
  updateSelfServeStatus: (selfServeId: string) => `/self-serve/admin/update-status/${selfServeId}`,
  uploadNDA: (selfServeId: string) => `/self-serve/admin/upload-nda/${selfServeId}`,
  toggleArchiveStatus: (selfServeId: string) => `/self-serve/admin/toggle-archived/${selfServeId}`,
  deleteSelfServe: (selfServeId: string) => `/self-serve/admin/delete/${selfServeId}`,
  simulateProjections: (subModuleId: string) =>
    `/visualization/submodules/${subModuleId}/predictions`,
  getPredictions: (submoduleId: string, gameId: string) =>
    `/visualization/submodules/${submoduleId}/predictions?gameId=${gameId}`,
  editProjections: (submoduleId: string, predictionId: string) =>
    `/visualization/submodules/${submoduleId}/predictions/${predictionId}/user-inputs`,
  selfServeAtachments: (selfServeId: string, attachmentId: string) =>
    `/self-serve/requests/${selfServeId}/attachments/${attachmentId}/download`,
  selfServeDataRequirementDocument: '/self-serve/doc-url',
  selfServeAggregatedCohortFileUpload: (selfServeId: string) =>
    `/self-serve/upload-data/${selfServeId}`,
  feedback: `/feedback`,
  cohortCount: (submoduleId: string, queryParams?: string) =>
    `/visualization/submodules/${submoduleId}/metadata?gameId=${queryParams || ''}`,
  fundingPercentage: (submoduleId: string, predictionId: string) =>
    `/visualization/submodules/${submoduleId}/predictions/${predictionId}/funding-percentage`,
  deals: `/deals`,
  games: `/games`,
  banks: '/banks',
  getBankDetails: (bankId: string) => `/banks/games/${bankId}`,
  selfServeAdminAggregatedCohortFileUpload: `/self-serve/admin/upload-data`,
  selfServeMonthlyRefresh: '/self-serve/refresh-config',
  createPortfolio: '/self-serve/admin/request/portfolios',
  portfolioDetails: (portfolioId: string) => `/self-serve/admin/request/portfolios/${portfolioId}`,
  refreshCommissions: '/commissions/refresh',
  commissions: (queryParams?: string) => `/commissions${queryParams ? `?${queryParams}` : ''}`,
  commissionsDownload: (queryParams?: string) =>
    `/commissions/download${queryParams ? `?${queryParams}` : ''}`,
  activeCohorts: (queryParams?: string) =>
    `/commissions/active-cohorts${queryParams ? `?${queryParams}` : ''}`,
  activeCohortsDownload: (queryParams?: string) =>
    `/commissions/active-cohorts/download${queryParams ? `?${queryParams}` : ''}`,
  payouts: (queryParams?: string) => `/commissions/payouts${queryParams ? `?${queryParams}` : ''}`,
  payoutsDownload: (queryParams?: string) =>
    `/commissions/payouts/download${queryParams ? `?${queryParams}` : ''}`,
  updatePayoutStatus: (id: string) => `/payments/${id}`,
  markActiveCohortAsDefaulted: (cohortId: string) =>
    `/commissions/active-cohorts/${cohortId}/mark-defaulted`,
  referrers: '/referrers',
  referrersByGameId: (gameId: string) => `/referrers/games/${gameId}`,
  commissionsFilters: '/commissions/filters',
  commissionsChart: (queryParams?: string) =>
    `/commissions/charts${queryParams ? `?${queryParams}` : ''}`,
  commissionsChartsDownload: (queryParams?: string) =>
    `/commissions/charts/download${queryParams ? `?${queryParams}` : ''}`,
  deletePortfolio: (portfolioId: string) => `/self-serve/admin/request/portfolios/${portfolioId}`,
  finalCommissions: (payoutId: string) => `/commissions/payouts/${payoutId}`,
  dealsCsvDownload: (queryParams?: string) =>
    `/games/download${queryParams ? `?${queryParams}` : ''}`,
  underwritingCharts: (submoduleId: string, queryParams?: string) =>
    `/visualization/submodules/${submoduleId}/tabs${queryParams}`,
};
